var onLoad = function(event) {
    $('.videoSlider__slider--carousel').owlCarousel({
      loop: true,
      items: 1,
      dots: true,
      nav: false,
      autoHeight: true,
      margin: 50
    });
    onResize();
  },
  onResize = function(event) {
    if ($('.videoSlider').length > 0 && window.innerWidth > 991) {
      $('.videoSlider__video--wrap').css({
        width: $('.videoSlider__slider').offset().left
      });
    } else {
      $('.videoSlider__video--wrap').css({
        width: ''
      });
    }
    onScroll();
  },
  onScroll = function(event) {};

$(window).on('scroll', onScroll);
$(window).on('resize', onResize);
$(window).on('load', onLoad);

$('textarea, input').on('change keyup keydown keypress', function() {
  if ($.trim(this.value).length > 0) {
    $(this).closest('.input, .file-div').addClass('full');
    $(this).removeClass('wpcf7-not-valid').closest('.input, .file-div').removeClass('error');
  } else {
    $(this).closest('.input, .file-div').removeClass('full');
  }
});

$('textarea, input').on('focusin', function() {
  $(this).closest('.input').addClass('focus');
});

$('textarea, input').on('focusout', function() {
  $(this).closest('.input').removeClass('focus');
});

$('body').on('click', '.fixedVideo', function(){
	$(this).fadeOut(300);
  $(this).find('video').get(0).pause();
});

$('body').on('click', '.videoSlider .svg__play', function(){
  var id = $(this).closest('.videoSlider__video--wrap').data('id');
  $('.fixedVideo#'+id).fadeIn(300);
	$('.fixedVideo#'+id+' video').get(0).play();
});

$('.fixedVideo video').get(0).addEventListener('ended', function(){
	$(this).closest('.fixedVideo').fadeOut(300);
	this.pause();
});
